import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { PRODUCTS } from "./data/products";

const mountNode = document.getElementById("wellness-quiz-widget");

if (mountNode) {
  const root = createRoot(mountNode);
  const products = PRODUCTS;
  root.render(<App products={products} />);
}
